export const CHART_SERIES = [
  {
    color: 'var(--mantine-other-colors-green)',
    name: 'balance',
  },
]
